/*
ModuleRegistry is a central point to locate modules.  It's outside of the canvas
to prevent any potential circular dependencies.
*/
define('modules/module-registry',[], function () {
  // Modules register their type with the canvas.  This is the storage area.
  var __moduleRegistry = {};

  // Static functions
  return {
    registerModule: function (type, modClass) {
      if (__moduleRegistry.hasOwnProperty(type)) {
        console.warn('ModuleRegistry already has a module registered under the key: ', type);
      }
      __moduleRegistry[type] = modClass;
    },

    module: function (type) {
      if (!__moduleRegistry.hasOwnProperty(type)) {
        console.error('ModuleRegistry does not have any module registered under the key: ', type);
        return;
      }

      return __moduleRegistry[type];
    },

    isRegistered: function (type) {
      return __moduleRegistry.hasOwnProperty(type);
    },

    instance: function (type) {
      if (!__moduleRegistry.hasOwnProperty(type)) {
        console.error('ModuleRegistry does not have any module registered under the key: ', type);
        return;
      }

      var args = Array.prototype.slice.call(arguments, 1);
      var impl = __moduleRegistry[type];

      args.unshift(null);

      return new (Function.prototype.bind.apply(impl, args));
    }
  }
});

